// extracted by mini-css-extract-plugin
module.exports = {"container":"GeoIPOverlay__container","content":"GeoIPOverlay__content","title":"GeoIPOverlay__title","buttonRight":"GeoIPOverlay__buttonRight"};